/* StartEcom product modules: reveal on scroll (also draws the PD16 strike-through). No dependencies. */
(() => {
  if (window.semInit) return;
  window.semInit = true;
  const roots = document.querySelectorAll('.semods');
  if (!roots.length) return;
  roots.forEach((r) => r.classList.add('sem-js'));
  const els = [...document.querySelectorAll('.semods .se-reveal:not(.is-in)')];
  const show = (e) => e.classList.add('is-in');
  if (!('IntersectionObserver' in window)) return els.forEach(show);
  const io = new IntersectionObserver((list) => list.forEach((x) => {
    if (x.isIntersecting) { show(x.target); io.unobserve(x.target); }
  }), { rootMargin: '0px 0px -12% 0px' });
  els.forEach((e) => io.observe(e));
})();
// Keep the repeated buy row on the variant chosen in the buy box (se-product-main fires se:variant-change).
document.addEventListener('se:variant-change', (e) => {
  const id = e.detail?.variant?.id;
  if (id) document.querySelectorAll('.sem-bf select').forEach((s) => { s.value = String(id); });
});
